import React from "react";

// Scss imports
import css from "./TextareaField.module.scss";

interface TextareaFieldProps {
  label: string;
  id: string;
  name: string;
  placeholder: string;
  value?: any;
  handleChange?: any;
  handleOnFocus: any;
  handleOnBlur: any;
  errorText?: string;
  minLength?: boolean;
  maxLength?: boolean;
  title?: boolean;
  refInput?: any;
  setEmail?: any;
  onInputHandler?: any;
  rowFormGroup?: boolean;
  minLabelWidth?: boolean;
  errorTextColumn?: string;
}

const TextareaField: React.FC<TextareaFieldProps> = ({
  label,
  id,
  name,
  placeholder,
  value,
  handleChange,
  handleOnFocus,
  handleOnBlur,
  errorText,
  onInputHandler,
  rowFormGroup,
  minLabelWidth,
  errorTextColumn
}) => {
  const maxLength: number = 250;
  const rows = 5;
  return (
    <div
      className={`${css.formGroup} ${rowFormGroup ? css.rowFormGroup : null}`}
    >
      <label
        className={`${minLabelWidth ? css.minLabelWidth : ""} ${
          rowFormGroup ? css.rowLabel : null
        }`}
        htmlFor={id}
      >
        {label}
      </label>
      {errorText !== "" && <p className={css.errorText}>{errorText}</p>}
      <div className={css.textareaErrorContainer}>
        <textarea
          name={name}
          id={id}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onFocus={handleOnFocus}
          onBlur={handleOnBlur}
          onInput={onInputHandler}
          className={`${rowFormGroup ? css.rowInput : null} ${
            errorTextColumn ? css.errorTextarea : ""
          }`}
          rows={rows}
          maxLength={maxLength}
        />
        {errorTextColumn !== "" && (
          <p className={css.errorText}>{errorTextColumn}</p>
        )}
      </div>
    </div>
  );
};

export default TextareaField;
